import * as React from 'react';
import { Card, Typography, Grid } from '@mui/material';
import CardActionComponent from '../card-action';

export function CardComponent({
  sx,
  classBorder,
  titleStyle,
  rows,
  uniqueKey,
  dataIcons,
  dataCardHeader,
  actionsIcons,
  handleActionClick,
}) {
  return (
    <Card
      className={classBorder}
      sx={{ ...sx }}
      key={rows.id + `${uniqueKey ? uniqueKey : '-key'}`}
    >
      <Grid container spacing={3} style={{ margin: 'auto' }}>
        {dataCardHeader &&
          Object.keys(dataCardHeader).length > 0 &&
          dataCardHeader.map((t, index) => (
            <Grid
              key={index + 'title'}
              className={titleStyle}
              item
              xs={t.gridSize}
            >
              {rows[t.id]}
            </Grid>
          ))}
        {dataIcons &&
          Object.keys(dataIcons).length > 0 &&
          dataIcons.map((el, index) => (
            <>
              <Grid
                key={index + 'key'}
                item
                xs={el.gridTitleSize ? el.gridTitleSize : 0}
              >
                <Typography>{el.title ? el.title : ''}</Typography>
              </Grid>
              <Grid item xs={el.gridSize}>
                <Typography className={titleStyle}>{rows[el.id]}</Typography>
              </Grid>
            </>
          ))}
      </Grid>
      <CardActionComponent
        actionsIcons={actionsIcons}
        handleActionClick={handleActionClick}
        row={rows}
      />
    </Card>
  );
}
